import React from "react";

const DocumentFilehtml= () => {
  
        return (
            <div>
                  <div className="container-fluid   position-relative">
                    <div className="row team-directories g-3">
                      <div className="col-xl-12">
                        
                        <div className="form-head d-flex flex-wrap align-items-center justify-content-between">
                          <div className="me-auto">
                            <h2 className="font-w600 mb-0">Documents Repository</h2>
                            <p>Simplify document storage & Collabration for your team.</p>
                          </div>
                          <div className="rightside-tabs">
                            <div className="d-flex">
                              <div class="dropdown documents-dropdown favourite-icon">
                              <button
                                    className=" me-2" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"/>
</svg>
                                    
                                  </button>
                               <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                  <li><a class="dropdown-item" href="#">Create Folder</a></li>
                                  <li><a class="dropdown-item" href="#">Upload Document</a></li>
                                  <li><a class="dropdown-item" href="#">Bulk Upload</a></li>
                                </ul>
                               
                                         </div>
                                    <div className="">
                                         <div className="actionbutton-tickets document-search">
                                        <input type="text" class="form-control" placeholder="Search Files & Folder"/>
                                    </div>
                                    </div>
                              
                            <div class="dropdown documents-dropdown">
                              <button
                                    className="add-newticket ms-0" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      className="bi bi-plus"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                    </svg>
                                    
                                  </button>
                               <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                  <li><a class="dropdown-item" href="#">Create Folder</a></li>
                                  <li><a class="dropdown-item" href="#">Upload Document</a></li>
                                  <li><a class="dropdown-item" href="#">Bulk Upload</a></li>
                                </ul>
                               
                                         </div>
                              </div>
                              </div>
                        </div>
                      </div>
                      <div className="col-xl-12">
                        <div className="page-content-inner all-projects mt-0">
                            <div className="row justify-content-center">
                                <div className="col-lg-12">
                                    <div className=" document-area">
                                      <h3 className="top-title">
                                                Favourite
                                            </h3>
              
              <div className="folder-block-area">
                   
                       <div className="document-file-box active"> 
                           
                           <div className="content-area">
                              <h5>Vendors</h5>
                              <p>Yesterday at 4:73 AM</p>
                                 <p>20 item</p>
                              
                           </div>
                       </div>
                   
                  
                       <div className="document-file-box">
                           
                           <div className="content-area">
                              <h5>Sales</h5>
                              <p>November 9, 2022 </p>
                                 <p>20 item</p>
                              
                           </div>
                       </div>
                        <div className="document-file-box">
                           
                           <div className="content-area">
                              <h5>Sales</h5>
                              <p>November 9, 2022 </p>
                               <div className="d-flex justify-content-between">
                                 <p>20 item</p>
                                  <div class="dropdown documents-dropdown favourite-icon">
                              <button
                                    className=" " type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"/>
</svg>
                                    
                                  </button>
                               <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                  <li><a class="dropdown-item" href="#">Create Folder</a></li>
                                  <li><a class="dropdown-item" href="#">Upload Document</a></li>
                                  <li><a class="dropdown-item" href="#">Bulk Upload</a></li>
                                </ul>
                               
                                         </div>
                                        
                               </div>
                                 
                              
                           </div>
                       </div>
                       
                   
              </div>
                              </div>


                              <div className=" document-area">
                                  <h3 className="top-title">
                                      All
                                  </h3>
                                  <div className="files-block-area">
                                      
                                          <div className="sub-files-folder-area">
                                              <div className="folder-box">
                                                  <img src="https://cdn.pixabay.com/photo/2024/05/26/10/15/bird-8788491_1280.jpg" className="img-fluid"/>
                                              </div>
                                              <div className="content-area">
                                                  <h5>Sales</h5>
                                                  <p>November 9, 2022 </p>
                                                    <p>20 item</p>
                                                  
                                              </div>
                                          </div>
                                      
                                      
                                          <div className="sub-files-folder-area">
                                              <div className="folder-box">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-code" viewBox="0 0 16 16">
                                                    <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z"/>
                                                    <path d="M8.646 6.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 9 8.646 7.354a.5.5 0 0 1 0-.708m-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 9l1.647-1.646a.5.5 0 0 0 0-.708"/>
                                                  </svg>
                                              </div>
                                              <div className="content-area">
                                                  <h5>Sales</h5>
                                                  <p>November 9, 2022 </p>
                                                    <p>20 item</p>
                                                  
                                              </div>
                                          </div>
                                            <div className="sub-files-folder-area">
                                              <div className="folder-box">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-headphones" viewBox="0 0 16 16">
                                                    <path d="M8 3a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a6 6 0 1 1 12 0v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1V8a5 5 0 0 0-5-5"/>
                                                  </svg>
                                              </div>
                                              <div className="content-area">
                                                  <h5>Sales</h5>
                                                  <p>November 9, 2022 </p>
                                                    <p>20 item</p>
                                                  
                                              </div>
                                          </div>
                                            <div className="sub-files-folder-area">
                                              <div className="folder-box">
                                                  <img src="https://cdn.pixabay.com/photo/2024/05/26/10/15/bird-8788491_1280.jpg" className="img-fluid"/>
                                              </div>
                                              <div className="content-area">
                                                  <h5>Sales</h5>
                                                  <p>November 9, 2022 </p>
                                                    <p>20 item</p>
                                                  
                                              </div>
                                          </div>
                                            <div className="sub-files-folder-area">
                                              <div className="folder-box">
                                                  <img src="https://cdn.pixabay.com/photo/2024/05/26/10/15/bird-8788491_1280.jpg" className="img-fluid"/>
                                              </div>
                                              <div className="content-area">
                                                  <h5>Sales</h5>
                                                  <p>November 9, 2022 </p>
                                                    <p>20 item</p>
                                                  
                                              </div>
                                          </div>
                                          <div className="sub-files-folder-area">
                                              <div className="folder-box">
                                                  <img src="https://cdn.pixabay.com/photo/2024/05/26/10/15/bird-8788491_1280.jpg" className="img-fluid"/>
                                              </div>
                                              <div className="content-area">
                                                  <h5>Sales</h5>
                                                  <p>November 9, 2022 </p>
                                                    <p>20 item</p>
                                                  
                                              </div>
                                          </div>
                                      
                                      
                                          <div className="sub-files-folder-area">
                                              <div className="folder-box">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-code" viewBox="0 0 16 16">
                                                    <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z"/>
                                                    <path d="M8.646 6.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 9 8.646 7.354a.5.5 0 0 1 0-.708m-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 9l1.647-1.646a.5.5 0 0 0 0-.708"/>
                                                  </svg>
                                              </div>
                                              <div className="content-area">
                                                  <h5>Sales</h5>
                                                  <p>November 9, 2022 </p>
                                                    <p>20 item</p>
                                                  
                                              </div>
                                          </div>
                                            <div className="sub-files-folder-area">
                                              <div className="folder-box">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-headphones" viewBox="0 0 16 16">
                                                <path d="M8 3a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a6 6 0 1 1 12 0v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1V8a5 5 0 0 0-5-5"/>
                                              </svg>
                                              </div>
                                              <div className="content-area">
                                                  <h5>Sales</h5>
                                                  <p>November 9, 2022 </p>
                                                    <p>20 item</p>
                                                  
                                              </div>
                                          </div>
                                            <div className="sub-files-folder-area">
                                              <div className="folder-box">
                                                  <img src="https://cdn.pixabay.com/photo/2024/05/26/10/15/bird-8788491_1280.jpg" className="img-fluid"/>
                                              </div>
                                              <div className="content-area">
                                                  <h5>Sales</h5>
                                                  <p>November 9, 2022 </p>
                                                    <p>20 item</p>
                                                  
                                              </div>
                                          </div>
                                           <div className="document-file-box">
                           
                           <div className="content-area">
                              <h5>Sales</h5>
                              <p>November 9, 2022 </p>
                                 <p>20 item</p>
                              
                           </div>
                       </div>
                        <div className="document-file-box">
                           
                           <div className="content-area">
                              <h5>Sales</h5>
                              <p>November 9, 2022 </p>
                                 <p>20 item</p>
                              
                           </div>
                       </div>
                       
                                          
                                      
                                  </div>
                              </div>
                              
                                </div>
                            </div>
                        </div>
                      </div>
                     
                     
                      
            
                     
                    </div>
                   
                  </div>
                </div>
      )
}


 export default DocumentFilehtml;